import { useContext, useState } from "react";
import { MdClose, MdKeyboardArrowDown } from "react-icons/md";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import { serviceMenuGroups } from "../ones/ServicesContent";
import Backdrop from "./Backdrop";

const primaryLinks = [
  { label: "Home", item: "home" },
  { label: "About Us", item: "about_us" },
  { label: "Contact Us", item: "contact_us" },
];

export default function SideBar() {
  const appContext = useContext(AppContext);
  const [showServices, setShowServices] = useState(false);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });
    closeSideBar();
  }

  function goToService(slug) {
    appContext.navTo({ item: "services", subItem: slug });
    closeSideBar();
  }

  return (
    <>
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9998",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
        }}
      />

      <aside className="SideBar" data-open={appContext.isSideBarOpen}>
        <div className="body mNoScrollBar">
          <div className="vex-mobile-shell">
            <div className="vex-mobile-topbar">
              <button
                type="button"
                className="vex-mobile-brand"
                onClick={() => goTo("home")}
              >
                <img src={logo} alt="VEX logo" />
                <div className="vex-mobile-brand-copy">
                  <strong>VEX</strong>
                  <span>Supply and Distribution</span>
                  <small>Transform people's way of life</small>
                </div>
              </button>

              <button
                type="button"
                className="vex-mobile-close"
                onClick={closeSideBar}
                aria-label="Close navigation menu"
              >
                <MdClose />
              </button>
            </div>

            <div className="vex-mobile-links">
              {primaryLinks.map((link) => (
                <button
                  key={link.item}
                  type="button"
                  className="vex-mobile-link"
                  onClick={() => goTo(link.item)}
                >
                  <strong>{link.label}</strong>
                </button>
              ))}

              <div className="vex-mobile-services-block">
                <button
                  type="button"
                  className="vex-mobile-link vex-mobile-link-services"
                  onClick={() => setShowServices((prev) => !prev)}
                >
                  <strong>Services</strong>
                  <MdKeyboardArrowDown
                    className="vex-mobile-services-caret"
                    data-open={showServices}
                  />
                </button>

                <div
                  className="vex-mobile-service-grid"
                  data-open={showServices}
                >
                  {serviceMenuGroups.map((group) => (
                    <button
                      key={group.slug}
                      type="button"
                      className="vex-mobile-service-section-title"
                      onClick={() => goToService(group.slug)}
                    >
                      {group.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="vex-mobile-contact">
              <a href="tel:+255767105804">+255 767 105 804</a>
              <a href="mailto:supply@vex-traders.co.tz">
                supply@vex-traders.co.tz
              </a>
              <p>Near Mlimani City, Dar Es Salaam, Tanzania</p>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
